import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import SubtleBadge from '@/components/common/SubtleBadge';
import { formatExecutionSource } from '../../utils/execution-source';

const SOURCE_META: Record<string, { label: string; icon: IconProp }> = {
  manual: { label: 'دستی', icon: 'pencil-alt' },
  scheduled: { label: 'زمان‌بندی‌شده', icon: 'clock' },
  api: { label: 'API', icon: 'link' },
  batch: { label: 'دسته‌ای', icon: 'layer-group' },
};

export function ExecutionSourceBadge({ source }: { source?: string | null }) {
  const formatted = formatExecutionSource(source);
  if (!formatted) return null;
  const normalized = source?.trim().toLowerCase() ?? '';
  const meta = SOURCE_META[normalized];
  const label = meta?.label ?? formatted;
  const icon = meta?.icon ?? 'tag';

  return (
    <SubtleBadge bg="secondary" pill>
      <span className="d-inline-flex align-items-center gap-1">
        <FontAwesomeIcon icon={icon} className="fs--2" />
        <span>{label}</span>
      </span>
    </SubtleBadge>
  );
}
